//angular imports
import {
  TemplateRef,
  Component,
  OnDestroy,
  WritableSignal,
  signal,
  ChangeDetectionStrategy,
  computed,
  Signal
} from '@angular/core';

//ngx-bootstrap imports
import {
  BsModalRef,
  BsModalService,
  ModalOptions
} from 'ngx-bootstrap/modal';

//local

import {
  CloseDialogMessage,
  Messenger
} from '@app/shared';

//local imports
import { PresenterType } from "@app/shared";
import { CatalogHeaderModel, HidePrintRoomPropertiesMessage, PrintRoomPropertiesLoadedMessage, PrintRoomPropertiesMessage, ShowPrintRoomPropertiesMessage } from '@app/catalog';

@PresenterType(
{
    model: CatalogHeaderModel 
})
@Component({
    selector: 'catalog-header',
    templateUrl: './catalog-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CatalogHeaderComponent implements OnDestroy {
    public data: WritableSignal<CatalogHeaderModel> = signal<CatalogHeaderModel>(null);

    public bsModalRef?: BsModalRef;
    public printLoading = signal(false);
    public showPrintButton = signal(false); 

    
    constructor(
      private messenger: Messenger,
      private modalService: BsModalService) 
    {           

      this.messenger.subscribe(this, ShowPrintRoomPropertiesMessage, () => {
        this.showPrintButton.set(true);
      });


      this.messenger.subscribe(this, HidePrintRoomPropertiesMessage, () => {
        this.showPrintButton.set(false);
      });


      this.messenger.subscribe(this, PrintRoomPropertiesLoadedMessage, () => {
        this.printLoading.set(false);
      });

      this.messenger.subscribe(this, CloseDialogMessage, msg => {

        //if (msg.handled) return;
  
        //TODO:DIW:Check CloseDialogMessage + show toast.
        this.bsModalRef?.hide();
  
        msg.handled = true;
      });
    } 

    public openForm(template: TemplateRef<void>) {
      const initialState: ModalOptions = {
        class: 'form-modal',
      };
      this.bsModalRef = this.modalService.show(template, initialState);
    }

    public sendPrintPropertiesMessage(){
      this.printLoading.set(true);
      this.messenger.send(new PrintRoomPropertiesMessage(false));
    }

    ngOnDestroy(): void {
      this.messenger.unsubscribeByOwner(this);
    }
}